import { FixedSizeList as List } from "react-window";
import styled from "styled-components";
import { zIndex } from "../../../NavigationBar/theme";

export const wrapperPadding = 8;
export const treeMaxWidth = 400;
export const treeMaxHeight = 366;

export const StyledWrapper = styled.div`
  background-color: rgb(255 255 255 / 100%);
  max-height: 420px;
  max-width: ${treeMaxWidth}px;
  box-shadow: 0 4px 16px rgb(0 0 0 / 16%);
  border-radius: 8px;
  overflow-x: hidden;
  position: relative;
  font-family: sans-serif, "DM Sans";
`;

export const StyledSearchContainer = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  padding: ${wrapperPadding}px;
  background-color: rgb(255 255 255 / 100%);
  z-index: ${zIndex.overContentMenu};
`;

export const StyledTreeContainer = styled.div`
  width: 100%;
`;

export const StyledList = styled(List)`
  padding-bottom: 8px;
`;
